import {
  GET_NOTIFICATIONS_CONFIG,
  GET_NOTIFICATIONS_CONFIG_ERROR,
  GET_NOTIFICATIONS_CONFIG_SUCCESS
} from './Notifications.actions'

const NotificationsState = {
  loading: false,
  error: undefined,
  notifications: [],
  lastFetch: null
}

/**
 * The NotificationsReducer reducer.
 */
const NotificationsReducer = (state = NotificationsState, { payload, type }) => {
  switch (type) {
    case GET_NOTIFICATIONS_CONFIG:
      return { ...state, loading: true }
    case GET_NOTIFICATIONS_CONFIG_ERROR:
      return { ...state, loading: false, error: payload?.error }
    case GET_NOTIFICATIONS_CONFIG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        notifications: payload?.payload ?? [],
        lastFetch: Date.now()
      }
    default: {
      return state
    }
  }
}

export default NotificationsReducer
